import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../services/api";
import "../style.css";

export default function Blogs() {
  const nav = useNavigate();

  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ totalPages: 1 });

  async function load(p = 1, query = "") {
    const res = await api.get(`/blogs?page=${p}&limit=10&q=${encodeURIComponent(query)}`);
    setItems(res.data.data || []);
    setMeta(res.data.pagination || { totalPages: 1, page: 1 });
    setPage(res.data.pagination?.page || 1);
  }

  useEffect(() => {
    load(1, "").catch(() => {});
  }, []);

  async function remove(id) {
    if (!window.confirm("Delete blog? This also deletes images.")) return;
    await api.delete(`/blogs/${id}`);
    await load(1, q);
  }

  return (
    <Layout>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <h2>Blogs</h2>
        <button className="btn btn-primary" onClick={() => nav("/blogs/new")}>+ New Blog</button>
      </div>

      <div className="card" style={{ marginTop: 12, padding: 12 }}>
        <div style={{ display: "flex", gap: 10 }}>
          <input
            style={{ flex: 1, padding: 10, borderRadius: 12, border: "1px solid var(--border)" }}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search title, tags, focus keyword..."
          />
          <button className="btn btn-ghost" onClick={() => load(1, q)}>Search</button>
        </div>
      </div>

      <div className="card" style={{ marginTop: 12 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Category</th>
              <th>Status</th>
              <th>Posted</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {items.map((b) => (
              <tr key={b._id}>
                <td style={{ fontWeight: 900 }}>
                  {b.title}
                  <div className="muted" style={{ fontSize: 12 }}>{b.slug}</div>
                </td>
                <td className="muted">{b.category?.name || "-"}</td>
                <td>
                  {b.status === "published" ? <span className="badge">Published</span> : <span className="badge">Draft</span>}
                </td>
                <td className="muted">{new Date(b.postedDate).toLocaleDateString()}</td>
                <td>
                  <div className="actions">
                    <Link className="btn btn-ghost" to={`/blogs/${b._id}/edit`}>Edit</Link>
                    <button className="btn btn-danger" onClick={() => remove(b._id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}

            {!items.length ? (
              <tr>
                <td colSpan="5" className="muted">No blogs found.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12 }}>
        <button className="btn btn-ghost" disabled={page <= 1} onClick={() => load(page - 1, q)}>Prev</button>
        <div className="muted">Page {page} of {meta.totalPages}</div>
        <button className="btn btn-ghost" disabled={page >= meta.totalPages} onClick={() => load(page + 1, q)}>Next</button>
      </div>
    </Layout>
  );
}
